module.exports = __webpack_public_path__ + "img/johannes-huther-icon.308fdf09.svg";